import React, { useContext, useEffect, useState } from "react";
import { useGetRolesUsersQuery } from "../../../../Redux/service/Roles&Permissions/RolesPermissions";
import { filtrationcontext } from "../../../../context/Filtercontext";
import trans, { isRTL } from "../../../../utils";
import { formatDateString } from "../../../../JsHelpers/DateFormat";
import AntdTable from "../../../antd/Table/Table";
import { capitalize } from "lodash";

export default function RolesUsers({ roleId }) {
	const {
		limit,
		setLimit,
		setSort: SetSortFilter,
		searchQuery,
		setSearchQuery,
	} = useContext(filtrationcontext);
	const [page, setPage] = useState(1);
	const [sort, setSort] = useState({
		by: "",
		order: "",
	});
	useEffect(() => {
		return () => {
			SetSortFilter({ type: "", value: "" });
		};
	}, [SetSortFilter, setSearchQuery]);

	useEffect(() => {
		setPage(1);
	}, [searchQuery]);
	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			setSort({
				by: sorter.field,
				order: sorter.order === "ascend" ? "asc" : "desc",
			});
		} else {
			setSort({
				by: "",
				order: "",
			});
		}
	};
	const { data, isLoading } = useGetRolesUsersQuery(
		{
			page: page,
			limit: limit,
			sortby: sort.by,
			sortorder: sort.order,
			id: roleId,
		},
		{ skip: !roleId },
	);
	const Column = [
		{
			title: trans("Name"),
			dataIndex: "name",
			width: 180,
			render: (_, record) => (
				<span className={"table-element-name ps-0"}>{record?.user?.name}</span>
			),
		},
		{
			title: trans("Email"),
			dataIndex: "email",
			width: 180,
			render: (_, record) => <span>{record?.user?.email}</span>,
		},
		{
			title: trans("Assigned By"),
			dataIndex: "assignbyName",
			width: 150,
			render: (_, record) => <span>{record?.assignedByUser?.name}</span>,
		},
		{
			title: trans("role"),
			dataIndex: "role",
			width: 150,
			capitalize: true,
			render: (_, record) => <span>{record?.role?.name}</span>,
		},

		{
			title: trans("Assigned At"),
			dataIndex: "assignedAt",
			width: 150,
			render: (assignedAt) => <span>{formatDateString(assignedAt)}</span>,
		},
		{
			title: trans("Expires At"),
			dataIndex: "expiresAt",
			width: 150,
			render: (expiresAt) => <span>{formatDateString(expiresAt)}</span>,
		},
	];
	return (
		<>
			<div className="bg-white-rounded-top table-parent">
				<AntdTable
					columns={Column}
					loading={isLoading}
					dataSource={data?.data || []}
					pageSize={limit}
					totalItems={data?.totalResults || 0} // Total count for pagination
					currentPage={page}
					onPageChange={(page) => setPage(page)}
					onLimitChange={(newLimit) => {
						setLimit(newLimit);
						setPage(1);
					}}
					onTableChange={handleTableChange}
				/>
			</div>
		</>
	);
}
